import React, { useMemo } from 'react';
import { callEventPlan, usePlan } from "../../../../../contexts/PlanOperationContext/Plan";
import { selectPermissions, selectTenantId } from '../../../../../util/store/selectors';
import { getStore, useSelector } from '../../../../../util/store/store';
import { checkLimit } from '../../../../../util/varibles/global';
import { IContract, IVessel } from "../../../../../util/varibles/interface";
import { ACTION } from '../../../../../util/varibles/permission';
import { EL_RULE, unavailableBg, VESSEL_COLOR } from "../constants";
import styles from "./style.module.scss";

interface IProps {
    vesselIndex: number
    contract: IContract
    vessel: IVessel
    width: number
}

const Contract: React.FC<IProps> = (props) => {
    const { vesselIndex, contract, width, vessel } = props;
    const { setTarget } = callEventPlan();
    const { tenant_id } = contract;
    const [canManageContract] = useSelector(selectPermissions([ACTION.PLAN_OP.CONTRACT]));
    const [finishTime] = usePlan(state => state.endCalendar)

    const isOwn = useMemo(() => tenant_id === selectTenantId(getStore()), [tenant_id])

    const handleContentMenu = (e: any) => {
        if (!isOwn) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        setTarget({ type: EL_RULE.CONTRACT, time: Date.now(), contract, vessel }, e)
    }

    const { start_time, finish_time, contract_code, id, type } = contract;
    const color = VESSEL_COLOR[(vesselIndex + 1) % VESSEL_COLOR.length];
    const background = isOwn ? {
        background: color,
    } : {
        backgroundAttachment: 'fixed',
        backgroundImage: unavailableBg(color),
    };

    const end = checkLimit(0, finishTime, finish_time);

    const style = {
        '--start-contract': start_time,
        width: width + '%',
        left: `${width * vesselIndex}%`,
        maxHeight: `${(end - start_time) / 86400000 * 120}px`,
    }

    return <div id={contract_code} {...{
        className: styles.contract,
        style: { ...style, ...background },
        'data-rule': EL_RULE.CONTRACT,
        'data-contract-id': id,
        'data-contract-type': type,
        'data-is-own': isOwn,
        ...canManageContract
            ? { onMouseDown: handleContentMenu, onContextMenu: handleContentMenu }
            : {}
    }} />;
};

export default Contract;
